<template>
    <modal
        id="company-asset-assign-log-modal"
        size="large"
        v-model="showModal"
        :title="$t('activity_log')"
        :hide-footer="true"
        @close="$emit('close')"
        :preloader="loading"
    >
        <div v-if="loading" class="text-center py-4">
            <app-pre-loader/>
        </div>
        <div v-else>
            <div v-if="logs.length" class="table-responsive datatable">
                <table class="table table-sm assign-log-table">
                    <thead>
                    <tr>
                        <th class="w-10">#</th>
                        <th class="w-25">{{ $t('employee') }}</th>
                        <th class="w-20">{{ $t('start_time') }}</th>
                        <th class="w-20">{{ $t('end_time') }}</th>
                        <th class="w-25">{{ $t('remark') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(log, index) in logs" :key="log.id">
                        <td>{{ index + 1 }}</td>
                        <td class="text-capitalize">{{ log.employee ? log.employee.full_name : '-' }}</td>
                        <td>{{ formatDate(log.start_time) }}</td>
                        <td>{{ log.end_time ? formatDate(log.end_time) : '-' }}</td>
                        <td class="text-break">{{ log.remark || '-' }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="text-center py-3">
                {{ $t('no_data_available') }}
            </div>
        </div>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import {formatDateToLocal} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "CompanyAssetAssignLogModal",
    mixins: [ModalMixin, HelperMixin],
    props: {
        assetId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            logs: [],
            loading: false,
        }
    },
    created() {
        this.fetchLogs();
    },
    methods: {
        fetchLogs() {
            this.loading = true;
            axiosGet(`${this.apiUrl.ASSET_ASSIGNS}?company_asset_id=${this.assetId}`)
                .then(({data}) => {
                    this.logs = data.data || data;
                })
                .catch(({response}) => {
                    this.$toastr.e('', response?.data?.message || this.$t('failed_response'));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatDate(date) {
            return formatDateToLocal(date, true);
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep .assign-log-table {
    th {
        border-top: none;
    }
    th, td {
        padding: 15px;
    }
}
</style>
